import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-heart-line text-lg"></i>
                </span>
                <span className="text-lg font-semibold text-background-50 font-heading">
                  爱情岛网址导航
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed">
                提供爱情岛最新官方入口、备用地址及安全使用指南，收藏本页随时获取最新地址更新。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {navLinks.slice(0, 4).map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">服务支持</h4>
              <div className="flex flex-col gap-2">
                {navLinks.slice(4).map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">安全提示</h4>
              <p className="text-sm text-background-300 leading-relaxed">
                请通过本页提供的官方入口访问爱情岛，注意识别钓鱼网站，保护个人信息和账户安全。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; {new Date().getFullYear()} 爱情岛网址导航 版权所有
            </p>
            <p className="text-sm text-background-500">
              本站仅提供网址导航服务，不存储任何用户数据
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}